<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">الخدمة الطبية والإجراءات (العيادات الخارجية)</h3>
            <div class="img-wrap">
                <img alt="" class="" src="/resource/img/">
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">مرضى لأول مره (زيارة لأول مره)e</h3>
            <h4 class="depth bullet02">الخدمة المباشرة دون موعد مسبق</h4>
            <p class="depth">
                يرجى ملء نموذج طلب الخدمة في B1 في الطابق الثالث. خذ تذكرة قائمة الانتظار وأرسل نموذج طلب الخدمة، وبطاقة التأمين الصحي الخاصة بك، وبطاقة هويتك إلى مكتب الاستقبال حيث يتم عرض رقمك. وسيتم إصدار بطاقة موعد خدمة العيادات الخارجية وبطاقة التأمين الصحي. أرسل بطاقة موعد خدمة العيادات الخارجية إلى قسم العيادات الخارجية.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">للمرضى العائدين (زيارة متكررة لمتابعة العلاج)</h3>
            <h4 class="depth bullet02">إذا كنت قد حجزت موعداً بالفعل</h4>
            <p class="depth">يرجى الوصول قبل الموعد المقرر بـ 10 دقائق على الأقل والوصول مباشرة إلى القسم.</p>
            <p class="depth">قدم بطاقة الموعد إلى القسم الذي تزوره.</p>
            <h4 class="depth bullet02">في حالة تحديد موعدا عبر الهاتف أو عبر الإنترنت (الهاتف أو الإنترنت أو الهاتف المحمول)</h4>
            <p class="depth">يرجى الوصول قبل الموعد المقرر بـ 10 دقائق على الأقل والوصول مباشرة إلى القسم.</p>
            <p class="depth">يرجى إظهار الرسالة النصية لإشعار الموعد إلى مكتب الاستقبال في القسم.</p>
            <h4 class="depth bullet02">الخدمة المباشرة، دون موعد</h4>
            <p class="depth">اسحب تذكرة الانتظار وأرسل نموذج طلب الخدمة وبطاقة التأمين الصحي إلى مكتب الاستقبال حيث يتم عرض رقمك. وسيتم إصدار بطاقة موعد في العيادات الخارجية. قدم بطاقة موعد خدمة العيادات الخارجية إلى القسم.</p>
            <p class="depth font-sub">※ قد يتم إغلاق خدمة الزيارة دون موعد في وقت مبكر وذلك وفقاً لظروف القسم.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>